import UIComponent from "../../common/UIComponent";
import "./index.css";
import { debounce } from "../../common/Utils";
export default class VolumeBtn extends UIComponent {

  constructor(elementId, interfaces) {
    super(interfaces);
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.nowVolume = 100;
    this.init();
    this.interfaces.on(VhallPlayer.VOLUME_CHANGE, () => {
      if (this.interfaces.getVolume() === 0) {
        this.volumeBtn.classList.add("mute");
      } else {
        this.volumeBtn.classList.remove("mute");
      }
    });

    this.interfaces.on(VhallPlayer.MUTE_CHANGE, res => {
      const muted = res.newValue;
      if (muted) {
        this.volumeBtn.classList.add("mute");
      } else {
        this.volumeBtn.classList.remove("mute");
      }
    });
  }

  init() {
    this.volumeComponent = document.createElement("div");
    this.volumeComponent.setAttribute("class", "vhallPlayer-volume-component");
    this.volumeComponent.onmouseleave = this.handleComponentMouseLeave.bind(this);

    this.volumeBtn = document.createElement("span");
    this.volumeBtn.setAttribute("class", "vhallPlayer-volume-btn");
    this.volumeBtn.onclick = this.handleBtnClick.bind(this);
    this.volumeBtn.onmouseenter = this.handleVolumeBtnEnter.bind(this);
    if(this.interfaces.vhallplayer.player.video.muted == true) {
      this.volumeBtn.classList.add("mute");
    }

    this.verticalSliderPopup = document.createElement("div");
    this.verticalSliderPopup.setAttribute('class', "vhallPlayer-verticalSlider-popup");

    this.verticalSliderBox = document.createElement("div");
    this.verticalSliderBox.setAttribute('class', "vhallPlayer-verticalSlider-box");

    this.verticalSliderTxt = document.createElement("span");
    this.verticalSliderTxt.setAttribute('class', "verticalSlider-txt");
    this.verticalSliderTxt.textContent = '50';

    this.verticalSliderRange = document.createElement("div");
    this.verticalSliderRange.setAttribute("class", "verticalSlider-range");
    this.verticalSliderRange.onclick = this.handlerRangeClick.bind(this);

    this.verticalSliderValue = document.createElement("div");
    this.verticalSliderValue.setAttribute("class", "verticalSlider-value");
    this.verticalSliderValue.style.height = `${this.interfaces.getVolume()}%`;

    this.verticalSliderCircle = document.createElement("div");
    this.verticalSliderCircle.setAttribute("class", "verticalSlider-circle");
    this.verticalSliderCircle.onmousedown = this.handlerMouseDown.bind(this);
    this.verticalSliderCircle.style.top = `${100-this.interfaces.getVolume()}%`;

    this.verticalSliderRange.appendChild(this.verticalSliderValue);
    this.verticalSliderRange.appendChild(this.verticalSliderCircle);
    if(this.theme) {
      this.verticalSliderBox.appendChild(this.verticalSliderTxt);
    }
    this.verticalSliderBox.appendChild(this.verticalSliderRange);
    this.verticalSliderPopup.appendChild(this.verticalSliderBox);

    this.volumeComponent.appendChild(this.volumeBtn);
    this.volumeComponent.appendChild(this.verticalSliderPopup);
    this.insertElement(this.elementId, this.volumeComponent);

  }


  handleVolumeBtnEnter() {
    this.volumeBtn.classList.add("active");
    this.verticalSliderPopup.style.display = "block";
  }


  handleBtnClick() {
    if (!this.interfaces.vhallplayer.player.video.muted) {
      this.interfaces.setVolume(0);
      this.verticalSliderTxt.textContent = 0;
      this.verticalSliderCircle.style.top = (this.verticalSliderRange.offsetHeight - this.verticalSliderCircle.offsetHeight) + 'px';
      this.verticalSliderValue.style.height = 0 + 'px';
    } else {
      this.nowVolume = this.nowVolume === 0 ? 100 : this.nowVolume;  // 拖动至静音时，再点击设置为50%
      let top = (this.verticalSliderRange.offsetHeight - this.verticalSliderCircle.offsetHeight) / (100 / this.nowVolume);
      this.interfaces.setVolume(this.nowVolume);
      this.verticalSliderTxt.textContent = this.nowVolume;
      this.verticalSliderCircle.style.top = Math.round(this.verticalSliderRange.offsetHeight - this.verticalSliderCircle.offsetHeight - top) + 'px';
      this.verticalSliderValue.style.height = top + 'px';
    }
  }

  handleComponentMouseLeave() {
    this.volumeBtn.classList.remove("active");
    this.verticalSliderPopup.style.display = "none";
  }

  handlerRangeClick(event) {
    if (event.target.className === "verticalSlider-circle") { return false; }

    let top = event.offsetY - this.verticalSliderCircle.offsetHeight;
    const difference = this.verticalSliderRange.offsetHeight - this.verticalSliderCircle.offsetHeight;  // 计算差值
    if (top < 0) { top = 0 };
    if (top >= difference) { top = difference };
    this.verticalSliderCircle.style.top = top + 'px';
    this.verticalSliderValue.style.height = (this.verticalSliderRange.offsetHeight - top) + 'px';

    const percent = 100 - Math.round(top / difference * 100) // 计算比例
    this.nowVolume = percent;
    this.interfaces.setVolume(percent);
    this.verticalSliderTxt.textContent = this.nowVolume;
  }

  handlerMouseDown(event) {
    this.isMouseDown = true;
    const circleTop = this.verticalSliderCircle.offsetTop;
    const difference = this.verticalSliderRange.offsetHeight - this.verticalSliderCircle.offsetHeight;  // 计算差值
    const mouseY = event.clientY;
    this.verticalSliderBox.onmousemove = event => {
      const moveT = event.clientY - mouseY;
      let newT = circleTop + moveT;
      // 判断最大值和最小值
      if (newT < 0) { newT = 0 }
      if (newT >= difference) { newT = difference }

      this.verticalSliderCircle.style.top = newT + 'px';
      this.verticalSliderValue.style.height = (this.verticalSliderRange.offsetHeight - newT) + 'px';

      const percent = 100 - Math.round(newT / difference * 100) // 计算比例
      this.nowVolume = percent;
      this.interfaces.setVolume(percent);
      this.verticalSliderTxt.textContent = percent;
    }
    document.onmouseup = () => {
      if (this.isMouseDown) {
        this.verticalSliderBox.onmousemove = null;
        document.onmouseup = null;
      }
    }
  }

}